<template>
  <div>
    <b-container fluid>
      <h3 class="mt-3 mb-3">Order Master</h3>

      <div class="search_bar mb-2" v-if="$store.state.user_obj &&
        $store.state.user_obj.user_name != 'lna_client'
      ">
        <b-row v-if="checkPermission(
          $store.state.user_obj,
          'Order Management',
          'Order Master',
          'Order Master Upload',
          true
        )
        ">
          <b-col cols="4" class="pr-1">
            <b-form-file v-model="upload_file" placeholder="Choose a file..." size="sm"></b-form-file>
          </b-col>

          <b-col class="text-left p-0">
            <b-button class="btn-action" size="sm" variant="info" @click="onUploadFile">Upload</b-button>
          </b-col>
        </b-row>
        <b-row class="mt-2" v-if="($store.state.user_obj.client_id == 11 || $store.state.user_obj.client_id == 77)
          &&
          checkPermission(
            $store.state.user_obj,
            'Order Management',
            'Order Master',
            'Order Master Upload',
            true
          )
        ">
          <b-col cols="4" class="pr-1">
            <b-form-file v-model="upload_file_edit" placeholder="Choose a file..." size="sm"></b-form-file>
          </b-col>

          <b-col class="text-left p-0">
            <b-button class="btn-action" size="sm" variant="info" @click="onUploadFileEdit">Upload Edit</b-button>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="12" sm="12" md="4" class="pr-1">
            <b-button class="btn-action" size="sm" variant="info" @click="pullEccanOrders" v-if="checkPermission(
              $store.state.user_obj,
              'Order Management',
              'Order Master',
              'Pull Eccang Orders',
              false
            )
            ">Pull Eccang Orders</b-button>

            <b-button class="btn-action" size="sm" variant="info" @click="pullShopifyOrders" v-if="checkPermission(
              $store.state.user_obj,
              'Order Management',
              'Order Master',
              'Pull Shopify Orders',
              true
            )
            ">Pull Shopify Orders</b-button>

            <b-button class="btn-action" size="sm" variant="info" @click="pullWoocomOrders" v-if="checkPermission(
              $store.state.user_obj,
              'Order Management',
              'Order Master',
              'Pull Woocom Orders',
              false
            )
            ">Pull Woocom Orders</b-button>

            <!-- <b-button class="btn-action" size="sm" variant="info" @click="showPullOrderModal" v-if="checkPermission(
              $store.state.user_obj,
              'Order Management',
              'Order Master',
              'Pull HKTVMALL',
              ($store.state.user_obj.client_profile.hktvmall_mode != null)
            )
            ">Pull HKTVMALL Orders</b-button>

            <b-button class="btn-action" size="sm" variant="info" @click="pullHKTVMALLWaybills" v-if="checkPermission(
              $store.state.user_obj,
              'Order Management',
              'Order Master',
              'Pull HKTVMALL',
              ($store.state.user_obj.client_profile.hktvmall_mode != null)
            )
            ">Pull HKTVMALL Waybill</b-button> -->
          </b-col>
        </b-row>
      </div>

      <div class="search_bar mb-1">
        <b-card>
          <b-row class="mb-1">
            <b-col cols="12" sm="12" md="2" class="pl-1 pr-1">
              <b-form-select size="sm" v-model="search_criteria.channel_selected" :options="channel_options" />
            </b-col>
            <b-col cols="12" sm="12" md="2" class="pl-0 pr-1" v-if="$store.state.user_obj.client_id == 3">
              <b-form-select size="sm" v-model="search_criteria.client_selected" :options="client_options" />
            </b-col>
            <b-col cols="12" sm="12" md="2" class="pl-0 pr-1">
              <b-form-select size="sm" v-model="search_criteria.order_status_selected"
                :options="order_status_options" />
            </b-col>
            <b-col cols="12" sm="12" md="2" class="pl-0 pr-1">
              <b-form-select size="sm" v-model="search_criteria.stock_status_selected"
                :options="stock_status_options" />
            </b-col>
            <b-col cols="12" sm="12" md="2" class="pl-0 pr-1">
              <b-form-select size="sm" v-model="search_criteria.fulfilment_status_selected"
                :options="fulfilment_status_options" />
            </b-col>

            <b-col cols="12" sm="12" md="2" class="pl-0 pr-1">
              <b-form-checkbox id="checkbox-order_alert_selected" v-model="search_criteria.order_alert_selected"
                name="checkbox-order_alert_selected" value="red" :unchecked-value="null">
                High Risk
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col cols="12" sm="12" md="2" class="pl-1 pr-1">
              <!-- <strong>Order Date </strong> -->
              <b-form-input id="input-small" size="sm" type="text" placeholder="Order#" value="Order Date"
                :disabled="true"></b-form-input>
            </b-col>
            <b-col cols="12" sm="12" md="2" class="pl-0 pr-1">
              <b-form-input id="input-small" size="sm" type="date" v-model="search_criteria.start_at"></b-form-input>
            </b-col>
            <b-col cols="12" sm="12" md="2" class="pl-0 pr-1">
              <b-form-input id="input-small" size="sm" type="date" v-model="search_criteria.end_at"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col cols="12" sm="12" md="2" class="pl-1 pr-1">
              <b-form-select size="sm" v-model="search_criteria.scheduled_delivery_date"
                :options="scheduled_delivery_date_options" />
            </b-col>
            <b-col cols="12" sm="12" md="2" class="pl-0 pr-1"
              v-if="search_criteria.scheduled_delivery_date == 'scheduled_date_yes'">
              <b-form-input id="input-small" size="sm" type="date"
                v-model="search_criteria.scheduled_delivery_date_start_at"></b-form-input>
            </b-col>
            <b-col cols="12" sm="12" md="2" class="pl-0 pr-1"
              v-if="search_criteria.scheduled_delivery_date == 'scheduled_date_yes'">
              <b-form-input id="input-small" size="sm" type="date"
                v-model="search_criteria.scheduled_delivery_date_end_at"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col cols="12" sm="12" md="2" class="pl-1 pr-1">
              <b-form-select size="sm" v-model="search_criteria.fulfilment_date" :options="fulfilment_date_options" />
            </b-col>
            <b-col cols="12" sm="12" md="2" class="pl-0 pr-1"
              v-if="search_criteria.fulfilment_date == 'fulfilment_date_yes'">
              <b-form-input id="input-small" size="sm" type="date" v-model="search_criteria.fulfilment_date_start_at" />
            </b-col>
            <b-col cols="12" sm="12" md="2" class="pl-0 pr-1"
              v-if="search_criteria.fulfilment_date == 'fulfilment_date_yes'">
              <b-form-input id="input-small" size="sm" type="date" v-model="search_criteria.fulfilment_date_end_at" />
            </b-col>
          </b-row>
          <b-row class="mb-1" v-if="$store.state.user_obj.client_id == '77'">
            <b-col cols="12" sm="12" md="2" class="pl-1 pr-1">
              <b-form-select size="sm" v-model="search_criteria.collection_date" :options="collection_date_options" />
            </b-col>
            <b-col cols="12" sm="12" md="2" class="pl-0 pr-1"
              v-if="search_criteria.collection_date == 'collection_date_yes'">
              <b-form-input id="input-small" size="sm" type="date"
                v-model="search_criteria.collection_date_start_at"></b-form-input>
            </b-col>
            <b-col cols="12" sm="12" md="2" class="pl-0 pr-1"
              v-if="search_criteria.collection_date == 'collection_date_yes'">
              <b-form-input id="input-small" size="sm" type="date"
                v-model="search_criteria.collection_date_end_at"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col cols="12" sm="12" md="4" class="pl-1 pr-1">
              <b-form-input id="input-small" size="sm" type="text" placeholder="Order#"
                v-model="search_criteria.keyword"></b-form-input>
            </b-col>

            <b-col class="text-left p-0">
              <b-button class="btn-action" size="sm" variant="info" @click="onSearch" v-if="checkPermission(
                $store.state.user_obj,
                'Order Management',
                'Order Master',
                'Search',
                true
              )
              ">
                <font-awesome-icon class="mr-1" icon="search" />Search
              </b-button>

              <b-button class="btn-action" size="sm" variant="info" @click="exportCSV" v-if="checkPermission(
                $store.state.user_obj,
                'Order Management',
                'Order Master',
                'Export CSV',
                true
              )
              ">Export</b-button>
              <b-button class="btn-action" size="sm" variant="info" @click="exportOrderTrackingMaster" v-if="checkPermission(
                $store.state.user_obj,
                'Order Management',
                'Order Master',
                'Export Order Tracking Master',
                true
              )
              ">Export Order Tracking Master</b-button>
            </b-col>
          </b-row>
          <b-row v-if="$store.state.user_obj.client_id == '69'">
            <b-col cols="12" sm="12" md="4" class="pl-0 pr-1 mt-1">
              <b-button class="btn-action" size="sm" variant="info" @click="exportAMLo2oActive">Export Active
                Stock</b-button>

              <b-button class="btn-action" size="sm" variant="info" @click="exportAMLo2oStockout">Export Total Stock
                Out</b-button>
            </b-col>
          </b-row>
        </b-card>
      </div>

      <div class="search_bar mb-3">
        <b-card>
          <!-- <strong>Outstanding:</strong> -->
          <b-row>
            <b-col cols="12" sm="12" md="2">
              <div class="cusor_pointer">
                <strong> Order Status </strong>
                <div class="row-status_cnt" @click="onSearchByStatus('order_status_selected', 'cancel')">
                  <div style="width: 90px">Cancel</div>
                  <div>
                    <span class="dot_red"></span>
                    <span>
                      {{ outstanding_order_cnts.cancel }}
                    </span>
                  </div>
                </div>

                <div class="row-status_cnt" @click="onSearchByStatus('order_status_selected', 'pending')">
                  <div style="width: 90px">Pending</div>
                  <div>
                    <span class="dot_yellow"></span>
                    <span>
                      {{ outstanding_order_cnts.pending }}
                    </span>
                  </div>
                </div>

                <div class="row-status_cnt" @click="onSearchByStatus('order_status_selected', 'received')">
                  <div style="width: 90px">Received</div>
                  <div>
                    <span class="dot_green"></span>
                    <span>
                      {{ outstanding_order_cnts.received }}
                    </span>
                  </div>
                </div>

                <div class="row-status_cnt" @click="onSearchByStatus('order_status_selected', 'hold')">
                  <div style="width: 90px">Hold</div>
                  <div>
                    <span class="dot_grey"></span>
                    <span>
                      {{ outstanding_order_cnts.hold }}
                    </span>
                  </div>
                </div>
              </div>
            </b-col>

            <b-col cols="12" sm="12" md="2">
              <div class="cusor_pointer">
                <strong> Stock Status </strong>
                <div class="row-status_cnt" @click="onSearchByStatus('stock_status_selected', 'pending')">
                  <div style="width: 90px">Pending</div>
                  <div>
                    <span class="dot_red"></span>
                    <span>
                      {{ outstanding_stock_cnts.pending }}
                    </span>
                  </div>
                </div>

                <div class="row-status_cnt" @click="
                  onSearchByStatus('stock_status_selected', 'available')
                  ">
                  <div style="width: 90px">Available</div>
                  <div>
                    <span class="dot_yellow"></span>
                    <span>
                      {{ outstanding_stock_cnts.available }}
                    </span>
                  </div>
                </div>

                <div class="row-status_cnt" @click="
                  onSearchByStatus('stock_status_selected', 'committed')
                  ">
                  <div style="width: 90px">Committed</div>
                  <div>
                    <span class="dot_green"></span>
                    <span>
                      {{ outstanding_stock_cnts.committed }}
                    </span>
                  </div>
                </div>
              </div>
            </b-col>

            <b-col cols="12" sm="12" md="3">
              <div class="cusor_pointer">
                <strong> Fulfilment Status </strong>
                <div class="row-status_cnt" @click="
                  onSearchByStatus('fulfilment_status_selected', 'pending')
                  ">
                  <div style="width: 180px">Pending</div>
                  <div>
                    <span class="dot_red"></span>
                    <span>
                      {{ outstanding_fulfilment_cnts.pending }}
                    </span>
                  </div>
                </div>

                <div class="row-status_cnt" @click="
                  onSearchByStatus(
                    'fulfilment_status_selected',
                    'start_picking'
                  )
                  ">
                  <div style="width: 180px">Picking in Progress</div>
                  <div>
                    <span class="dot_yellow"></span>
                    <span>
                      {{ outstanding_fulfilment_cnts.start_picking }}
                    </span>
                  </div>
                </div>

                <div class="row-status_cnt" @click="
                  onSearchByStatus(
                    'fulfilment_status_selected',
                    'cannot_find_inventory'
                  )
                  ">
                  <div style="width: 180px">Picking Issues</div>
                  <div>
                    <span class="dot_grey"></span>
                    <span>
                      {{ outstanding_fulfilment_cnts.cannot_find_inventory }}
                    </span>
                  </div>
                </div>

                <div class="row-status_cnt" @click="
                  onSearchByStatus('fulfilment_status_selected', 'fulfiled')
                  ">
                  <div style="width: 180px">Fulfiled</div>
                  <div>
                    <span class="dot_green"></span>
                    <span>
                      {{ outstanding_fulfilment_cnts.fulfiled }}
                    </span>
                  </div>
                </div>

                <!-- <div
                  class="row-status_cnt"
                  @click="
                    onSearchByStatus('fulfilment_status_selected', 'cannot_find_inventory')
                  "
                >
                  <div style="width: 180px;">Cannot Find Inventory</div>
                  <div>
                    <span class="dot_red"></span>
                    <span>
                      {{ outstanding_fulfilment_cnts.cannot_find_inventory }}
                    </span>
                  </div>
                </div>

                <div
                  class="row-status_cnt"
                  @click="
                    onSearchByStatus('fulfilment_status_selected', 'other_issues')
                  "
                >
                  <div style="width: 180px;">Other Issues</div>
                  <div>
                    <span class="dot_red"></span>
                    <span>
                      {{ outstanding_fulfilment_cnts.other_issues }}
                    </span>
                  </div>
                </div> -->
              </div>
            </b-col>

            <b-col cols="12" sm="12" md="2">
              <div class="cusor_pointer">
                <strong> BO Status </strong>
                <div class="row-status_cnt">
                  <div style="width: 150px">NO BO (Pending)</div>
                  <div>
                    <span class="dot_white"></span>
                    <span>
                      {{ bo_cnts.no_bo_pending }}
                    </span>
                  </div>
                </div>

                <div class="row-status_cnt">
                  <div style="width: 150px">BO (Pending)</div>
                  <div>
                    <span class="dot_red"></span>
                    <span>
                      {{ bo_cnts.bo_pending }}
                    </span>
                  </div>
                </div>

                <div class="row-status_cnt">
                  <div style="width: 150px">BO (Available)</div>
                  <div>
                    <span class="dot_yellow"></span>
                    <span>
                      {{ bo_cnts.bo_available }}
                    </span>
                  </div>
                </div>

                <div class="row-status_cnt">
                  <div style="width: 150px">BO (Committed)</div>
                  <div>
                    <span class="dot_green"></span>
                    <span>
                      {{ bo_cnts.bo_committed }}
                    </span>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <hr />

          <b-row class="mt-1 mb-1" v-if="$store.state.user_obj &&
            $store.state.user_obj.user_name != 'lna_client'
          ">
            <b-col class="">
              <b-button class="btn-action" size="sm" variant="info" @click="onBulkAction('receive')" v-if="checkPermission(
                $store.state.user_obj,
                'Order Management',
                'Order Master',
                'Bulk Receive',
                $store.state.user_obj && $store.state.user_obj.account_type == 'client_admin'
              )
              ">
                Bulk Receive
              </b-button>

              <b-button class="btn-action" size="sm" variant="info" @click="onBulkAction('commit')" v-if="checkPermission(
                $store.state.user_obj,
                'Order Management',
                'Order Master',
                'Bulk Commit',
                $store.state.user_obj && $store.state.user_obj.account_type == 'client_admin'
              )
              ">
                Bulk Commit
              </b-button>

              <b-button class="btn-action" size="sm" variant="info" @click="commitAll()" v-if="false &&
                checkPermission(
                  $store.state.user_obj,
                  'Order Management',
                  'Order Master',
                  'Commit All',
                  $store.state.user_obj &&
                  $store.state.user_obj.name != 'travelpop_new_client'
                )
              ">
                Commit ALL
              </b-button>

              <b-button class="btn-action" size="sm" variant="info" @click="showModal_confirmFulfil()" v-if="checkPermission(
                $store.state.user_obj,
                'Order Management',
                'Order Master',
                'Bulk Fulfil',
                $store.state.user_obj && $store.state.user_obj.account_type == 'client_admin'
              )
              ">
                Bulk Fulfill
              </b-button>

              <b-button v-if="checkPermission(
                $store.state.user_obj,
                'Order Management',
                'Order Master',
                'Order Create',
                $store.state.user_obj.permissions.order_add
              )
              " class="btn-action" size="sm" variant="info" :to="{
                name: 'order_master_add',
              }">
                Add Order
              </b-button>
              <b-button class="btn-action" size="sm" variant="info" @click="downloadSelectedDocs" v-if="checkPermission(
                $store.state.user_obj,
                'Order Management',
                'Order Master',
                'Bulk Fulfil',
                $store.state.user_obj && $store.state.user_obj.account_type == 'client_admin'
              )
              ">
                Download Docs
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </div>

      <strong># of Records: {{ total_rows }}</strong>

      <b-row class="mb-1">
        <b-col cols="1" class="pr-0">
          <b-form-select size="sm" v-model="sel_table_limit" :options="[50, 100, 200, 500]"
            @change="getOrderMaster()" />
        </b-col>
        <b-col class="pl-0 pr-1">
          <b-pagination size="sm" :total-rows="total_rows" v-model="currentPage" :per-page="sel_table_limit"
            @change="onPageChange" :limit="PAGING_LIMIT"></b-pagination>
        </b-col>
      </b-row>

      <b-table responsive small outlined striped hover :items="items" :fields="fields" :tbody-tr-class="rowClass">
        <template v-slot:head(chk_box)="data">
          <b-form-checkbox size="sm" plain id="chkbox_all" value="all" v-model="check_all_rows"></b-form-checkbox>
        </template>
        <template v-slot:cell(chk_box)="data">
          <b-form-checkbox size="sm" class="chkbox_row" plain :id="'chkbox_row_' + data.index"
            v-model="data.item.is_checked"></b-form-checkbox>
        </template>

        <template v-slot:cell(order_date)="data">
          {{ displayDate(data.item.order_date) }}
        </template>

        <template v-slot:cell(order_number)="data">
          <router-link :to="{
            name: 'order_master_detail',
            params: { order_master_id: data.item.id },
          }">
            {{ data.item.order_number }}
          </router-link>
        </template>

        <template v-slot:cell(related_orders)="data">
          <span v-if="data.item.related_orders.length == 0" class="dot_white"></span>

          <span v-if="data.item.related_orders.length > 0" class="dot_green"></span>
        </template>

        <template v-slot:cell(payment_status)="data">
          {{ data.item.payment_status || "-" }}
        </template>

        <template v-slot:cell(order_import_status)="data">
          <div>
            <span class="span-status">{{ data.item.order_import_status }}</span>

            <span v-if="data.item.order_import_status == 'cancel'" class="dot_red"></span>
            <span v-if="data.item.order_import_status.toLowerCase() == 'hold'" class="dot_grey"></span>
            <span v-if="data.item.order_import_status == 'pending'" class="dot_yellow"></span>
            <span v-if="data.item.order_import_status == 'received'" class="dot_green"></span>
          </div>
        </template>

        <template v-slot:cell(stock_status)="data">
          <div>
            <span class="span-status">{{ data.item.stock_status }}</span>

            <span v-if="data.item.stock_status == '-'" class="dot_white"></span>
            <span v-if="data.item.stock_status == 'pending'" class="dot_red"></span>
            <span v-if="data.item.stock_status == 'available'" class="dot_yellow"></span>
            <span v-if="data.item.stock_status == 'committed'" class="dot_green"></span>
          </div>
        </template>

        <template v-slot:cell(fulfilment_status)="data">
          <div>
            <span class="span-status">{{ data.item.fulfilment_status }}</span>

            <span v-if="data.item.fulfilment_status == '-'" class="dot_white"></span>
            <span v-if="data.item.fulfilment_status == 'pending'" class="dot_yellow"></span>
            <span v-if="data.item.fulfilment_status == 'completed'" class="dot_green"></span>
            <span v-if="data.item.fulfilment_status == 'fulfiled'" class="dot_green"></span>
            <span v-if="data.item.fulfilment_status == 'start_picking'" class="dot_yellow"></span>
            <span v-if="data.item.fulfilment_status == 'cannot_find_inventory'" class="dot_red"></span>
            <span v-if="data.item.fulfilment_status == 'other_issues'" class="dot_red"></span>
          </div>
        </template>

        <!-- <template v-slot:cell(delivery_status)="data">
          <div>
            
            <span v-if="data.item.delivery_status == '-'" class="dot_white"></span>
            <span v-if="data.item.delivery_status == 'pending'" class="dot_yellow"></span>
            <span v-if="data.item.delivery_status == 'completed'" class="dot_green"></span>
            <span v-if="data.item.delivery_status == 'fulfiled'" class="dot_green"></span>

          </div>
        </template> -->

        <template v-slot:cell(action)="data">
          <b-button v-if="checkPermission(
            $store.state.user_obj,
            'Order Management',
            'Order Master',
            'Receive Order',
            true
          ) && data.item.order_import_status != 'received'
          " class="btn-action" size="sm" variant="success" :disabled="(data.item.channel == 'Shopify' &&
            data.item.payment_status != 'paid' &&
            data.item.payment_status != 'Authorized') ||
            (data.item.channel == 'woocom' &&
              data.item.payment_status != 'paid') ||
            data.item.order_import_status == 'cancel'
            " @click="doReceiveOrder(data.item)">Receive</b-button>

          <b-button v-if="checkPermission(
            $store.state.user_obj,
            'Order Management',
            'Order Master',
            'Commit Order',
            true
          ) &&
            data.item.order_import_status == 'received' &&
            data.item.stock_status != 'committed'
          " class="btn-action" size="sm" variant="success"
            :disabled="data.item.order_import_status == 'cancel' || ($store.state.user_obj.account_type == 'client_user' && $store.state.user_obj.client_id != '46')"
            @click="doCommitOrder(data.item)">Commit</b-button>

          <!-- <b-button
            v-if="data.item.stock_status == 'committed'"
            class="btn-action"
            size="sm"
            variant="success"
            @click="doFulfillOrder(data.item)"
            >Fulfill</b-button
          > -->

          <b-button class="btn-action" size="sm" variant="danger"
            :disabled="data.item.order_import_status == 'cancel' || ($store.state.user_obj.account_type == 'client_user' && $store.state.user_obj.client_id != '46')"
            @click="showModal_confirmCancel(data.item)" v-if="checkPermission(
              $store.state.user_obj,
              'Order Management',
              'Order Master',
              'Cancel Order',
              true
            )
            ">Cancel</b-button>

          <b-button class="btn-action" size="sm" variant="warning"
            :disabled="data.item.order_import_status == 'cancel' || ($store.state.user_obj.account_type == 'client_user' && $store.state.user_obj.client_id != '46')"
            @click="doHoldOrder(data.item)" v-if="checkPermission(
              $store.state.user_obj,
              'Order Management',
              'Order Master',
              'Hold Order',
              true
            )
            ">Hold</b-button>
        </template>
      </b-table>

      <b-pagination size="sm" :total-rows="total_rows" v-model="currentPage" :per-page="sel_table_limit"
        @change="onPageChange" :limit="PAGING_LIMIT"></b-pagination>

      <b-modal ref="modal_confirmFulfil" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>Are you sure to bulk fulfil?</b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn class="mt-3" variant="outline-danger" @click="hideModal_confirmFulfil">Cancel</b-btn>
          <b-btn class="mt-3" variant="outline-success" @click="onBulkAction('fulfill')">Confirm</b-btn>
        </div>
      </b-modal>

      <b-modal ref="modal_confirmCancel" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>Are you sure to cancel?</b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn class="mt-3" variant="outline-danger" @click="hideModal_confirmCancel">Cancel</b-btn>
          <b-btn class="mt-3" variant="outline-success" @click="doCancelOrder(confirmCancel.row_data)">Confirm</b-btn>
        </div>
      </b-modal>

      <b-modal ref="modal_pullOrders" title="Select Date Range" hide-footer>
        <b-form-group label="Start Date">
          <b-form-input v-model="hktvmall_selectedStartDate" type="date"></b-form-input>
        </b-form-group>

        <b-form-group label="End Date">
          <b-form-input v-model="hktvmall_selectedEndDate" type="date"></b-form-input>
        </b-form-group>

        <!-- New Schedule Date Input -->
        <b-form-group label="Schedule Date">
          <b-form-input v-model="hktvmall_selectedScheduleDate" type="date"></b-form-input>
        </b-form-group>

        <div class="text-right">
          <b-btn variant="outline-danger" @click="$refs.modal_pullOrders.hide()">Cancel</b-btn>
          <b-btn variant="outline-success" @click="confirmPullHKTVMALLOrders">Confirm</b-btn>
        </div>
      </b-modal>

    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";
import apiService from "../services/ApiService";
import global_function from "../mixins/global_function";

const fields = [
  {
    key: "chk_box",
    label: "",
  },
  {
    key: "channel",
    label: "Channel",
  },
  {
    key: "order_date",
    label: "Order Date",
  },
  {
    key: "order_number",
    label: "Order#",
  },
  {
    key: "scheduled_delivery_date",
    label: "Delivery Date",
    class: "center_align",
  },
  // {
  //   key: "related_orders",
  //   label: "Grouped",
  //   class: "txt_camelcase center_align",
  // },
  {
    key: "payment_status",
    label: "Payment",
    class: "txt_camelcase center_align",
  },
  {
    key: "order_import_status",
    label: "Order Status",
    class: "txt_camelcase center_align container-status",
  },
  {
    key: "stock_status",
    label: "Stock Status",
    class: "txt_camelcase center_align container-status",
  },
  {
    key: "fulfilment_status",
    label: "Fulfilment Status",
    class: "txt_camelcase center_align container-status",
  },
  {
    key: "delivery_status",
    label: "Delivery Status",
    class: "txt_camelcase center_align",
  },
  {
    key: "action",
    label: "Action",
  },
];

const collection_fields = [
  {
    key: "chk_box",
    label: "",
  },
  {
    key: "channel",
    label: "Channel",
  },
  {
    key: "order_date",
    label: "Order Date",
  },
  {
    key: "order_number",
    label: "Order#",
  },
  {
    key: "scheduled_delivery_date",
    label: "Delivery Date",
    class: "center_align",
  },
  {
    key: "collection_date",
    label: "Collection Date",
    class: "center_align",
  },
  // {
  //   key: "related_orders",
  //   label: "Grouped",
  //   class: "txt_camelcase center_align",
  // },
  {
    key: "payment_status",
    label: "Payment",
    class: "txt_camelcase center_align",
  },
  {
    key: "order_import_status",
    label: "Order Status",
    class: "txt_camelcase center_align container-status",
  },
  {
    key: "stock_status",
    label: "Stock Status",
    class: "txt_camelcase center_align container-status",
  },
  {
    key: "fulfilment_status",
    label: "Fulfilment Status",
    class: "txt_camelcase center_align container-status",
  },
  {
    key: "delivery_status",
    label: "Delivery Status",
    class: "txt_camelcase center_align",
  },
  {
    key: "action",
    label: "Action",
  },
];

export default {
  name: "OrderMaster",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
  mixins: [apiService, global_function],
  components: {
    barcode: VueBarcode,
  },
  data() {
    return {
      hktvmall_selectedStartDate: moment().format("YYYY-MM-DD"),
      hktvmall_selectedEndDate: moment().format("YYYY-MM-DD"),
      hktvmall_selectedScheduleDate: moment().format("YYYY-MM-DD"),  // New property
      confirmCancel: {},
      sel_table_limit: 100,
      courier_options: [],
      export_date: {
        start_at: moment().subtract(7, "d").format("YYYY-MM-DD"),
        end_at: moment().format("YYYY-MM-DD"),
      },
      upload_file: [],
      upload_file_edit: [],
      loader_full: false,
      loader: false,
      items: [],
      fields: fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      updating_item: false,
      export_criteria: {
        courier_selected: null,
        channel_selected: null,
      },
      search_criteria: {
        keyword: "",
        channel_selected: null,
        client_selected: null,
        order_alert_selected: null,
        start_at: moment().subtract(3, "months").format("YYYY-MM-DD"),
        end_at: moment().format("YYYY-MM-DD"),
        scheduled_delivery_date_start_at: moment()
          .subtract(3, "months")
          .format("YYYY-MM-DD"),
        scheduled_delivery_date_end_at: moment()
          .add(1, "months")
          .format("YYYY-MM-DD"),
        collection_date_start_at: moment()
          .subtract(3, "months")
          .format("YYYY-MM-DD"),
        collection_date_end_at: moment()
          .add(1, "months")
          .format("YYYY-MM-DD"),
        fulfilment_date_start_at: moment()
          .subtract(3, "months")
          .format("YYYY-MM-DD"),
        fulfilment_date_end_at: moment()
          .add(1, "months")
          .format("YYYY-MM-DD"),
        order_status_selected: null,
        stock_status_selected: null,
        fulfilment_status_selected: null,
        scheduled_delivery_date: null,
        collection_date: null,
        fulfilment_date: null
      },
      showAlert_success: false,
      alert_success_message: "",

      showAlert_error: false,
      alert_error_message: "",

      channel_options: [
        {
          value: null,
          text: "All Channel",
        },
      ],

      client_options: [
        {
          value: null,
          text: "All Clients",
        },
      ],

      order_status_options: [
        {
          value: null,
          text: "All Order Status",
        },
        {
          value: "cancel",
          text: "Cancel",
        },
        {
          value: "received",
          text: "Received",
        },
        {
          value: "pending",
          text: "Pending",
        },
        {
          value: "hold",
          text: "Hold",
        },
      ],
      stock_status_options: [
        {
          value: null,
          text: "All Stock Status",
        },
        {
          value: "-",
          text: "-",
        },
        {
          value: "pending",
          text: "Pending",
        },
        {
          value: "available",
          text: "Available",
        },
        {
          value: "committed",
          text: "Committed",
        },
      ],

      fulfilment_status_options: [
        {
          value: null,
          text: "All Fulfilment Status",
        },
        {
          value: "fulfiled",
          text: "Fulfilled",
        },
        {
          value: "pending",
          text: "Pending",
        },

        {
          value: "start_picking",
          text: "Start Picking",
        },
        {
          value: "cannot_find_inventory",
          text: "Cannot Find Inventory",
        },
        {
          value: "other_issues",
          text: "Other Issues",
        },
      ],

      check_all_rows: false,
      outstanding_order_cnts: {},
      outstanding_stock_cnts: {},
      outstanding_fulfilment_cnts: {},
      bo_cnts: {},

      scheduled_delivery_date_options: [
        {
          value: null,
          text: "All Scheduled Date",
        },
        {
          value: "scheduled_date_yes",
          text: "Scheduled Delivery Date",
        },
        {
          value: "scheduled_date_no",
          text: "NO Scheduled Delivery Date",
        },
      ],

      collection_date_options: [
        {
          value: null,
          text: "All Collection Date",
        },
        {
          value: "collection_date_yes",
          text: "Collection Date",
        },
        {
          value: "collection_date_no",
          text: "NO Collection Date",
        },
      ],
      fulfilment_date: null,
      fulfilment_date_start_at: moment().subtract(3, "months").format("YYYY-MM-DD"),
      fulfilment_date_end_at: moment().add(1, "months").format("YYYY-MM-DD"),
      fulfilment_date_options: [
        { value: null, text: "All Fulfilment Date" },
        { value: "fulfilment_date_yes", text: "Fulfilment Date" },
        { value: "fulfilment_date_no", text: "NO Fulfilment Date" }
      ]

    };
  },
  async created() {
    await this.getOrderMaster();
    let channels_response = await this.getChannels(this.$store.state.user_obj);
    for (let i in channels_response.channels) {
      this.channel_options.push({
        value: channels_response.channels[i].name,
        text: channels_response.channels[i].name,
      });
    }

    let clients_response = await this.getClients(this.$store.state.user_obj);
    for (let i in clients_response.clients) {
      this.client_options.push({
        value: clients_response.clients[i].id,
        text: clients_response.clients[i].full_name,
      });
    }

    if (this.$store.state.user_obj.client_id == '77') {
      this.fields = collection_fields;
    }

    this.initialized = true;
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false,
    });
  },
  watch: {
    // whenever changes, this function will run
    check_all_rows: function (new_val, old_val) {
      // this.check_all_rows = !this.check_all_rows;
      console.log("check_all_rows");
      if (new_val == "all") {
        // Check all
        for (let i in this.items) {
          this.items[i].is_checked = true;
        }
      } else {
        for (let i in this.items) {
          this.items[i].is_checked = false;
        }
      }
      console.log(this.items);
    },
  },
  methods: {
    showModal_confirmFulfil() {
      this.$refs.modal_confirmFulfil.show();
    },

    hideModal_confirmFulfil() {
      this.$refs.modal_confirmFulfil.hide();
    },
    showModal_confirmCancel(row_data) {
      this.confirmCancel.row_data = row_data;
      this.$refs.modal_confirmCancel.show();
    },

    hideModal_confirmCancel() {
      this.$refs.modal_confirmCancel.hide();
    },
    exportCSV() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      this.$http({
        url: this.NODEJS_API_URL + "/gen_excel",
        method: "POST",
        data: {
          export_type: "order_master",
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
        responseType: "blob", // still needed
      })
        .then((response) => {
          const disposition = response.headers["content-disposition"];
          if (
            response.data.type === "application/json" ||
            !disposition ||
            disposition.indexOf("attachment") === -1
          ) {
            // Treat this as an error message in blob form
            const reader = new FileReader();
            reader.onload = () => {
              const errMsg = reader.result || "Unknown error occurred";
              this.$toast.error(errMsg); // or your preferred toast lib
              this.loader.hide();
            };
            reader.readAsText(response.data);
            return;
          }

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "order_master.xlsx");
          document.body.appendChild(link);
          link.click();

          this.loader.hide();
        })
        .catch((error) => {
          console.error("Export failed:", error);
          const reader = new FileReader();
          reader.onload = () => {
            const errMsg = reader.result || "Unexpected error occurred";
            this.$eventHub.$emit("show_modal_message", {
              message_content: errMsg,
              variant: "danger"
            });
            this.loader.hide();
          };

          if (error.response && error.response.data) {
            reader.readAsText(error.response.data);
          } else {
            this.$eventHub.$emit("show_modal_message", {
              message_content: "Network error or no response from server.",
              variant: "danger"
            });
            this.loader.hide();
          }
        });
    },

    exportOrderTrackingMaster() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      this.$http({
        url: this.NODEJS_API_URL + "/gen_excel",
        method: "POST",
        data: {
          export_type: "order_tracking_master",
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id,
        },
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "order_tracking_master.xlsx");
        document.body.appendChild(link);
        link.click();

        this.loader.hide();
      });
    },

    exportAMLo2oActive() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      this.$http({
        url: this.NODEJS_API_URL + "/gen_excel",
        method: "POST",
        data: {
          export_type: "aml_o2o_inventory_active",
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id,
        },
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "aml_o2o_inventory_active.xlsx");
        document.body.appendChild(link);
        link.click();

        this.loader.hide();
      });
    },

    exportAMLo2oStockout() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      this.$http({
        url: this.NODEJS_API_URL + "/gen_excel",
        method: "POST",
        data: {
          export_type: "aml_o2o_inventory_stockout",
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id,
        },
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "aml_o2o_inventory_stockout.xlsx");
        document.body.appendChild(link);
        link.click();

        this.loader.hide();
      });
    },

    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async bulkDownloadWayBill() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "hkt_bulk_waybill.php",
        data: {
          items: this.items,
        },
      });
      if (response.data.url) {
        window.open(response.data.url, "_blank");
      }
      this.loader.hide();
    },

    async updateImportStatus(row_data, status) {
      if (status == "cancel") {
        return;
      }
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_approval.php",
        data: {
          status: status,
          order_master_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Update Success",
        variant: "success",
      });
      this.getOrderMaster();
    },

    async doReceiveOrder(row_data) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_receive.php",
        data: {
          order_master_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Receive Order Success",
        variant: "success",
      });
      this.getOrderMaster();
    },

    async doCommitOrder(row_data) {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_commit.php",
        data: {
          order_master_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });

      if (response.data.status === "success") {
        this.$eventHub.$emit("show_alert_message", {
          alert_message: "Commit Order Success",
          variant: "success",
        });
      } else {
        this.$eventHub.$emit("show_modal_message", {
          message_content: response.data.error || "Commit Order Failed",
          variant: "danger"
        });
      }

      this.loader_full.hide();
      this.getOrderMaster();
    },

    async doCancelOrder(row_data) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_cancel.php",
        data: {
          order_master_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });

      console.log(response)

      if (response.data.status === "success") {
        this.$eventHub.$emit("show_alert_message", {
          alert_message: "Cancel Order Success",
          variant: "success"
        });
      } else {
        this.$eventHub.$emit("show_modal_message", {
          message_content: response.data.error || "Cancel Order Failed",
          variant: "danger"
        });
      }
      this.hideModal_confirmCancel();

      this.getOrderMaster();
    },

    async doHoldOrder(row_data) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_hold.php",
        data: {
          order_master_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Hold Order Success",
        variant: "success",
      });
      this.getOrderMaster();
    },

    async doFulfillOrder(row_data) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_fulfil.php",
        data: {
          order_master_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
          fromOrderMaster: true
        },
      });
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Fulfil Order Success",
        variant: "success",
      });
      this.getOrderMaster();
    },

    async updateFulfillStatus(row_data) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_fulfill.php",
        data: {
          order_master_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });

      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Update Success",
        variant: "success",
      });
      this.getOrderMaster();
    },

    async commitAll() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_commit_all.php",
        data: {
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });

      this.loader_full.hide();

      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Update Success",
        variant: "success",
      });
      this.getOrderMaster();
    },

    async onSearchByStatus(status_type, status_value) {
      this.search_criteria[status_type] = status_value;
      this.getOrderMaster();
    },

    async getOrderMaster() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_get.php",
        data: {
          offset: this.table_offset,
          limit: this.sel_table_limit,
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });
      this.items = response.data.orders;
      this.total_rows = parseInt(response.data.total_rows);
      this.outstanding_order_cnts = response.data.outstanding_order_cnts;
      this.outstanding_stock_cnts = response.data.outstanding_stock_cnts;
      this.outstanding_fulfilment_cnts =
        response.data.outstanding_fulfilment_cnts;
      this.bo_cnts = response.data.bo_cnts;
      this.loader.hide();
    },

    onSearch() {
      this.getOrderMaster();
    },

    onPageChange(page_to_change) {
      this.table_offset = (page_to_change - 1) * this.sel_table_limit;
      this.getOrderMaster();
    },

    downloadWaybill(data) {
      let url = process.env.WAYBILL_HOST + "/waybill?";
      url += "id=" + data.tracking_number;
      window.open(url, "_blank");
    },

    async onBulkAction(bulk_action) {
      this.hideModal_confirmFulfil();
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let order_master_ids = [];
      for (let i in this.items) {
        if (this.items[i].is_checked) {
          order_master_ids.push(this.items[i].id);
        }
      }

      // call action
      let action_urls = {
        receive: "order_master_receive.php",
        commit: "order_master_commit.php",
        fulfill: "order_master_fulfil.php",
      };

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: action_urls[bulk_action],
        data: {
          order_master_ids: order_master_ids,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
          fromOrderMaster: true
        },
      });

      this.loader_full.hide();
      if (bulk_action == 'commit') {
        if (response.data.status === "success") {
          this.$eventHub.$emit("show_alert_message", {
            alert_message: "Commit Order Success",
            variant: "success",
          });
        } else {
          this.$eventHub.$emit("show_modal_message", {
            message_content: response.data.error || "Cancel Order Failed",
            variant: "danger"
          });
        }
      } else {
        this.$eventHub.$emit("show_alert_message", {
          alert_message: "Bulk Update Success",
          variant: "success",
        });
      }

      this.getOrderMaster();
    },

    async onBulkApprove() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });
      let order_master_ids = [];
      for (let i in this.items) {
        if (
          this.items[i].is_checked &&
          this.items[i].order_import_status == "pending"
        ) {
          order_master_ids.push(this.items[i].id);
        }
      }

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_approval.php",
        data: {
          status: status,
          order_master_ids: order_master_ids,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });
      this.loader_full.hide();
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Update Success",
        variant: "success",
      });
      this.getOrderMaster();
    },

    async onBulkFulfill() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });
      let order_master_ids = [];
      for (let i in this.items) {
        if (
          this.items[i].is_checked &&
          this.items[i].order_import_status != "pending" &&
          this.items[i].fulfilment_status == "pending"
        ) {
          order_master_ids.push(this.items[i].id);
        }
      }

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_fulfill.php",
        data: {
          status: status,
          order_master_ids: order_master_ids,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });
      this.loader_full.hide();
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Update Success",
        variant: "success",
      });
      this.getOrderMaster();
    },

    async pullShopifyOrders() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      this.$http({
        url:
          this.NODEJS_API_URL +
          "/shopify_order_get?client_id=" +
          this.$store.state.user_obj.client_id,
        method: "GET",
        data: null,
      }).then((response) => {
        this.loader_full.hide();
        this.getOrderMaster();
        // let json_response = JSON.parse();
        this.$eventHub.$emit("show_modal_message", {
          message_content: `New Orders: ${response.data.cnt_new_order} \r\n Updated Orders: ${response.data.cnt_update_order}`,
        });
      });
    },

    async pullWoocomOrders() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      this.$http({
        url:
          this.NODEJS_API_URL +
          "/woocom_order_get?client_id=" +
          this.$store.state.user_obj.client_id,
        method: "GET",
        data: null,
      }).then((response) => {
        this.loader_full.hide();
        this.getOrderMaster();
        // let json_response = JSON.parse();
        this.$eventHub.$emit("show_modal_message", {
          message_content: `New Orders: ${response.data.cnt_new_order} \r\n Updated Orders: ${response.data.cnt_update_order}`,
        });
      });
    },

    async pullEccanOrders() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      this.$http({
        url:
          this.NODEJS_API_URL +
          "/eccang_pull_order?client_id=" +
          this.$store.state.user_obj.client_id,
        method: "GET",
        data: null,
      }).then((response) => {
        this.loader_full.hide();
        this.getOrderMaster();
        // let json_response = JSON.parse();
        this.$eventHub.$emit("show_modal_message", {
          message_content: `New Orders: ${response.data.cnt_new_order} \r\n Updated Orders: ${response.data.cnt_update_order}`,
        });
      });
    },

    async onUploadFile() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let formData = new FormData();
      formData.append("excel_file", this.upload_file);
      formData.append("user_id", this.$store.state.user_obj.user_id);
      formData.append("client_id", this.$store.state.user_obj.client_id);

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_import.php",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      });

      if (response) {
        this.loader_full.hide();
        if (response.data.status == "success") {
          this.$eventHub.$emit("show_modal_message", {
            message_content: "Upload Success",
          });
        } else {
          this.$eventHub.$emit("show_modal_message", {
            message_content: response.data.error_msg,
          });
        }
        this.getOrderMaster();
      }
    },

    async onUploadFileEdit() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let formData = new FormData();
      formData.append("excel_file", this.upload_file_edit);
      formData.append("user_id", this.$store.state.user_obj.user_id);
      formData.append("client_id", this.$store.state.user_obj.client_id);

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_edit_import.php",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      });

      if (response) {
        this.loader_full.hide();
        if (response.data.status == "success") {
          this.$eventHub.$emit("show_modal_message", {
            message_content: "Upload Success",
          });
        } else {
          this.$eventHub.$emit("show_modal_message", {
            message_content: response.data.error_msg,
          });
        }
        this.getOrderMaster();
      }
    },

    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.is_checked) return "table-info";
    },

    async pullHKTVMALLOrders() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "hktvmall_pull_order.php",
        data: {
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
          start_date: this.hktvmall_selectedStartDate,
          end_date: this.hktvmall_selectedEndDate,
          schedule_date: this.hktvmall_selectedScheduleDate, // Include schedule date
        },
      });
      this.loader_full.hide();
      if (response.data.status === "success") {
        this.$eventHub.$emit("show_alert_message", {
          alert_message: "Pulling orders",
          variant: "success",
        });
      } else {
        this.$eventHub.$emit("show_modal_message", {
          message_content: response.data.message || "Pull Order Failed",
          variant: "danger"
        });
      }
    },

    async pullHKTVMALLWaybills() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "hktvmall_pull_waybill.php",
        data: {
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });
      this.loader_full.hide();
      if (response.data.status === "success") {
        this.$eventHub.$emit("show_alert_message", {
          alert_message: "Pulling waybills",
          variant: "success",
        });
      } else {
        this.$eventHub.$emit("show_modal_message", {
          message_content: response.data.message || "Pull waybill Failed",
          variant: "danger"
        });
      }
    },

    showPullOrderModal() {
      this.selectedStartDate = moment().subtract(3, "months").format("YYYY-MM-DD");
      this.selectedEndDate = moment().format("YYYY-MM-DD");
      this.$refs.modal_pullOrders.show();
    },

    confirmPullHKTVMALLOrders() {
      this.$refs.modal_pullOrders.hide();
      this.pullHKTVMALLOrders();
    },
    async downloadSelectedDocs() {
  let order_master_ids = [];

  for (let i in this.items) {
    if (this.items[i].is_checked) {
      order_master_ids.push(this.items[i].id);
    }
  }

  if (order_master_ids.length === 0) {
    this.$eventHub.$emit("show_modal_message", {
      message_content: "Please select at least one order",
      variant: "danger",
    });
    return;
  }

  this.loader_full = this.$loading.show({
    isFullPage: true,
    canCancel: false,
  });

  try {
    const response = await this.$http({
      method: "POST",
      baseURL: `${this.API_HOST}`,
      url: "order_master_doc_download_bulk.php",
      data: {
        order_master_ids: order_master_ids,
        client_id: this.$store.state.user_obj.client_id,
        user_id: this.$store.state.user_obj.user_id,
      },
      responseType: "blob",
    });

    const disposition = response.headers["content-disposition"];
    if (
      response.data.type === "application/json" ||
      !disposition ||
      disposition.indexOf("attachment") === -1
    ) {
      const reader = new FileReader();
      reader.onload = () => {
        const errMsg = reader.result || "Download failed";
        this.$eventHub.$emit("show_modal_message", {
          message_content: errMsg,
          variant: "danger",
        });
        this.loader_full.hide();
      };
      reader.readAsText(response.data);
      return;
    }

    let filename = "order_master_docs.zip";
    const match = disposition.match(/filename="([^"]+)"/);
    if (match && match[1]) {
      filename = match[1];
    }

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    this.loader_full.hide();
  } catch (error) {
    console.error("Download docs failed:", error);

    const reader = new FileReader();
    reader.onload = () => {
      const errMsg = reader.result || "Unexpected error occurred";
      this.$eventHub.$emit("show_modal_message", {
        message_content: errMsg,
        variant: "danger",
      });
      this.loader_full.hide();
    };

    if (error.response && error.response.data) {
      reader.readAsText(error.response.data);
    } else {
      this.$eventHub.$emit("show_modal_message", {
        message_content: "Network error or no response from server.",
        variant: "danger",
      });
      this.loader_full.hide();
    }
  }
},
  },
};
</script>

<style>
th,
td {
  white-space: nowrap;
}

.span-status {
  display: none;
}

.container-status:hover .span-status {
  display: inline;
}

.row-status_cnt {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderMaster.vue